import axios from '@/request/http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块

const examinGoods = {
  //获取验货单列表信息（出库单）
  getExamineMainList (params) {
    return axios.post('/order/examineGoods/getExamineMainList', qs.stringify(params))
  },
  //获取验货单商品列表信息（出库单）
  getExamineGoodsList (params) {
    return axios.post('/order/examineGoods/getExamineGoodsList', qs.stringify(params))
  },
  //验收验货单商品信息（出库单）
  updateExamineGoodsNum (params) {
    return axios.post('/order/examineGoods/updateExamineGoodsNum', qs.stringify(params))
  },
  //提交验货单信息（出库单）
  submitExamineMain (params) {
    return axios.post('/order/examineGoods/submitExamineMain', qs.stringify(params))
  },
  //获取验货单详情信息（出库单）
  getExamineMainDetailList (params) {
    return axios.post('/order/examineGoods/getExamineMainDetailList', qs.stringify(params))
  },
  //一键验收验货单商品信息（出库单）接口
  batchUpdateExamineGoodsNum (params) {
    return axios.post('/order/examineGoods/batchUpdateExamineGoodsNum', qs.stringify(params))
  },
}
export default examinGoods


// WEBPACK FOOTER //
// ./src/request/api/order/examinGoods.js